import { render } from "./ErrorModal.vue?vue&type=template&id=b957a634&scoped=true&ts=true"
import script from "./ErrorModal.vue?vue&type=script&lang=ts"
export * from "./ErrorModal.vue?vue&type=script&lang=ts"

import "./ErrorModal.vue?vue&type=style&index=0&id=b957a634&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b957a634"]])

export default __exports__